<template>
  <div id="userLayout" class="user-layout-wrapper">
    <img class="bg" src="~@/assets/login/bg.png" />
    <div class="container">
      <div class="left">
        <div class="view">
          <div class="text">
            <img src="~@/assets/login/text.png" alt="text" />
          </div>
          <route-view></route-view>
        </div>
      </div>
      <div class="right">
        <img src="~@/assets/login/right.png" />
      </div>
    </div>
  </div>
</template>

<script>
import RouteView from "@/components/layouts/RouteView";

export default {
  name: "UserLayout",
  components: { RouteView },
  data() {
    return {};
  },
  mounted() {
    document.body.classList.add("userLayout");
  },
  beforeDestroy() {
    document.body.classList.remove("userLayout");
  },
};
</script>

<style lang="less" scoped>
#userLayout.user-layout-wrapper {
  height: 100%;
  background: linear-gradient(90deg, #9291fd 0%, #4b6fd9 100%);
  padding: 74px 0;
  position: relative;
  .bg {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 480px;
    height: 785px;
  }
  .container {
    margin: 0 72px;
    height: 100%;
    background: #eff5f9;
    border-radius: 20px;
    padding: 0 98px 0px 116px;
    padding-top: 41px;
    display: flex;
    .left {
      flex: 1;
      padding-top: 40px;
      .logo {
        margin-bottom: 103px;
        img {
          width: 206px;
        }
      }
      .view {
        margin-left: 18px;
      }
      .text img {
        width: 357px;
      }
    }
    .right {
      width: 599px;
      display: flex;
      align-items: center;
      img {
        width: 599px;
        height: 672px;
      }
    }
  }
}
</style>
